export default __webpack_public_path__ + "static/media/espresso.ab31c77c.jpg";